import { Typography } from '@remarkable/ark-web';

import { ComponentLocations } from 'src/analytics/trackingTypes';
import { useDeleteInvitation } from 'src/api/queries/invitations';
import { Button, Modal, NotificationBox } from 'src/components';

export const CancelInvitationModal = ({
  invitationLink,
  onSuccess,
}: {
  invitationLink: string;
  onSuccess: () => void;
}) => {
  const deleteInvitation = useDeleteInvitation();

  return (
    <Modal.Content>
      <Modal.Title asChild>
        <Typography variant="heading-md" className="mb-24">
          Cancel invitation
        </Typography>
      </Modal.Title>

      <Modal.Description asChild>
        <Typography variant="body-md" className="mb-16">
          Are you sure you want to cancel the invitation?
        </Typography>
      </Modal.Description>

      {deleteInvitation.isError && (
        <NotificationBox
          className="my-16"
          error={deleteInvitation.error}
          title="Something went wrong"
        >
          Something went wrong while cancelling the invitation. Please try again
          later or contact support if the problem persists.
        </NotificationBox>
      )}

      <div className="mt-24 flex justify-center gap-16">
        <Modal.Close asChild>
          <Button
            variant="secondary"
            data-cy="keep-invitation-button"
            analytics={{
              text: 'Keep invitation',
              location: ComponentLocations.MANAGE_CONNECT.MEMBERS_PAGE,
              action: 'keep invitation',
            }}
          >
            Keep invitation
          </Button>
        </Modal.Close>

        <Button
          onClick={() => {
            deleteInvitation.mutate(invitationLink, { onSuccess });
          }}
          loading={deleteInvitation.isPending}
          disabled={!invitationLink || deleteInvitation.isPending}
          data-cy="cancel-invitation-button"
          analytics={{
            text: 'Cancel invitation',
            location: ComponentLocations.MANAGE_CONNECT.MEMBERS_PAGE,
            action: 'cancel invitation',
          }}
        >
          Cancel invitation
        </Button>
      </div>
    </Modal.Content>
  );
};
